import { Component, Input, OnInit, Output, EventEmitter, ViewChild, OnChanges, ViewEncapsulation, ViewChildren, QueryList } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';
import { ClusterHeadNewList } from 'app/views/campaign-3/models/campaign-3-customer-target.model';
import { Campaign3Info, MessageInstanceRuleTypes, MessageInstanceObjectTypes, MessageInstanceObject, DistributionListCluster, DistributionListDetails, MessageInstanceRule, MessageInstanceRuleDetail } from 'app/views/campaign-3/models/campaign-3.model';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { MessageService } from 'primeng/primeng';



@Component({
  selector: 'app-message-3-customer-target',
  templateUrl: './message-3-customer-target.component.html',
  styleUrls: ['./message-3-customer-target.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Message3CustomerTargetComponent implements OnInit {

  @Input() campaignInfo: Campaign3Info = null;
  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() miRuleTypesList: Array<MessageInstanceRuleTypes> = [];
  @Input() miObjectTypesList: Array<MessageInstanceObjectTypes> = [];
  @Input() formSchema: any;
  @Input() schemaMode: string;
  @Input() messageInstanceObject: MessageInstanceObject;
  @Input() distributionListEmission: Array<DistributionListCluster> = [];

  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  // Periodo di emissione del messaggio, usato per escludere dalla "Crea nuova lista" i cluster scaduti
  // o futuri rispetto a questo periodo (vedi onClickCreaNuovaLista). Non esiste un periodo di fruizione
  // per il messaggio.
  @Input() dataInizioEmissione: Date = null;
  @Input() dataFineEmissione: Date = null;
  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();


  //primi campi soglia
  @ViewChild('listaDistribuzioneEmissione') listaDistribuzioneEmissione: FormFields;
  /*   @ViewChild('listaDistribuzioneFruizione') listaDistribuzioneFruizione: FormFields; */
  @ViewChild('tipoControllo') tipoControllo: FormFields;

  @ViewChild('switchCartaNecessaria') switchCartaNecessaria: FormFields;


  distributionList: Array<DistributionListCluster> = [];
  clusterHeadNewList: Array<ClusterHeadNewList> = [];
  distributionListDetails: Array<DistributionListDetails> = [];

  currentNuovaListaEmissioneFruizione = "";

  // Periodo di emissione da passare al modal "Crea nuova lista" per escludere i cluster scaduti o
  // futuri rispetto a tale periodo (il messaggio non ha un periodo di fruizione).
  currentActionDateStart: Date = null;
  currentActionDateEnd: Date = null;

  currentDistributionListId: number = null;

  valid: boolean = true;

  show = {
    form: false,
    modalDistributionList: false,
    modalDistributionListDetails: false,
    modalClusterHeadNewList: false
  }

  fieldModel = {
    listaDistribuzioneEmissione: null,

    tipoControllo: null
  }

  switch = {
    comeEmissione: false,
    cartaNecessaria: false
  }

  comboListaDistribuzioneEmissione: Array<DistributionListCluster>;
  /*  comboListaDistribuzioneFruizione: Array<DistributionListCluster>; */
  comboTipoControllo: Array<{ value: string, label: string }>;

  currentSearchType: string = "";

  title = {
    contenutoLista: "Contenuto Lista",
    creaNuovaLista: "Crea nuova lista"
  }

  CT_rules_emission: Array<MessageInstanceRule> = [];
  CT_rules_fruition: Array<MessageInstanceRule> = [];

  constructor(
    private srvCampaign3: Campaign3Service,
    private srvCalTranslate: CalendarTranslateService,
    private srvNotify: MessageService,
    private translate: TranslateService
  ) {

  }
  ngOnInit() {

    let distrubutionListNull = new DistributionListCluster();
    distrubutionListNull.distributionListId = null;
    distrubutionListNull.distributionListName = "";

    this.comboListaDistribuzioneEmissione = Object.assign([], this.distributionListEmission);
    /*     this.comboListaDistribuzioneFruizione = Object.assign([],this.distributionListFruition); */

    this.comboListaDistribuzioneEmissione.unshift(distrubutionListNull);
    /*     this.comboListaDistribuzioneFruizione.unshift(distrubutionListNull); */


    /*
    this.comboTipoControllo = [
      {code: 'G', name: "Qualunque carta valida"},
      {code: 'C', name: "Qualunque carta valida del cliente"},
      {code: 'S', name: "Carta associata al coupon"}
    ];
    */

    if (this.messageInstanceObject.flgCardHolder == "1") {
      this.switch.cartaNecessaria = true;
    }
    else if (this.messageInstanceObject.flgCardHolder == "0") {
      this.switch.cartaNecessaria = false;
    }

    this.resetSelectedClusterHeads();

    this.show.form = true;


    var self = this;
    setTimeout(function () {

      /*   self.comboTipoControllo = JSON.parse(JSON.stringify(Object.assign([],self.formSchema.form.tipo_controllo.options)));
  
        for(let opt of self.comboTipoControllo){
          opt.label = opt.label[self.language];
        } */

      //valorizzazione, caso edit
      if (self.messageInstanceObject && self.ui_mode == self.srvCampaign3.ui_modes.EDIT) {

        //self.switch.cartaNecessaria = self.fieldModel.tipoControllo ? true : false;

        self.switch.cartaNecessaria = self.messageInstanceObject.flgCardHolder == "1" ? true : false;

        var self2 = self;

        for (let mir of self.messageInstanceObject.messageInstanceRule) {
          if (mir.ruleTypeId == self.miRuleTypesList.find(x => x.code == "CT").id) {
            if (mir.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
              let mird = mir.messageInstanceRuleDetail.find(x => x.objectTypeId == self.miObjectTypesList.find(x => x.code == "TDIS").id);
              if (mird && mird.objectId) {
                self.fieldModel.listaDistribuzioneEmissione = self.comboListaDistribuzioneEmissione.find(x => x.distributionListId == mird.objectId);
              }
            }
            /*  if(mir.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.FRUITION){
               let mird = mir.messageInstanceRuleDetail.find(x=>x.objectTypeId == self.miObjectTypesList.find(x=>x.code == "TDIS").id);
               if(mird && mird.objectId){
                 self.fieldModel.listaDistribuzioneFruizione = self.comboListaDistribuzioneFruizione.find(x=>x.distributionListId == mird.objectId);
               }
             } */
          }
        }

        setTimeout(function () {
          self2.fieldModel.tipoControllo = self2.messageInstanceObject.cardHolderType ? self2.tipoControllo.options.find(x => x.value == self2.messageInstanceObject.cardHolderType) : null;
          self2.checkVincoliCustomerTarget();
        }, 100);

      }

    }, 100);
  }
  blockDistributionEmissionList() {
    this.fieldModel.listaDistribuzioneEmissione = null;
    this.listaDistribuzioneEmissione.required = false;
    this.listaDistribuzioneEmissione.disabled = true;
    let indexCT = this.messageInstanceObject.messageInstanceRule.findIndex(x => (x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "CT").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION));
    if (indexCT > -1) this.messageInstanceObject.messageInstanceRule.splice(indexCT, 1);
  }
  checkVincoliCustomerTarget() {

    /* Se la promo è statica (flg_couponing_method = 'S'), in edit_definitive non è possibile editare la lista di distribuzione */
    /*  if(this.messageInstanceObject.flgCouponingMethod == this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode && this.schemaMode == this.srvCampaign3.schema_modes.EDIT_DEFINITIVE){
       this.listaDistribuzioneFruizione.disabled = true;
     }
  */
    /* - Se la promo ha clienti destinati alla promo diverso da 'LOY' (target_loyalty_class ≠'LOY') non è attivabile
     (anche da KS-5420, se il tipo azione è NOLOY o ALL allora cancello e inibisco lista di distribuzione emissione)
     */
    if (this.messageInstanceObject.targetLoyaltyClass != this.srvCampaign3.clientiDestinatiPromo.LOY) {
      this.blockDistributionEmissionList();

      /*da KS-5420, se il tipo azione è NOLOY o ALL allora non devo poter scegliere "Qualunque carta valida del cliente" e "Carta associata al coupon".
        Essendo il tipo di controllo composto da soli 3 valori, l'unico che rimane è quello con codice G, perciò lo forzo */
      /*
      let tipiControlliCombo = [
        {code: 'G', name: "Qualunque carta valida"}
      ];
      */


      if (this.tipoControllo) {
        this.tipoControllo.required = true;
        this.tipoControllo.options = Object.assign([], [this.comboTipoControllo.find(x => x.value == this.srvCampaign3.tipoControllo.QUALUNQUE_CARTA_VALIDA)]);
        this.tipoControllo.fieldModel = this.messageInstanceObject.cardHolderType ? this.tipoControllo.options.find(x => x.value == this.messageInstanceObject.cardHolderType) : null;
      }

      this.fieldModel.tipoControllo = this.messageInstanceObject.cardHolderType ? this.tipoControllo.options.find(x => x.value == this.messageInstanceObject.cardHolderType) : null;
      //this.switch.cartaNecessaria = false;
    }
    else if (this.messageInstanceObject.targetLoyaltyClass == this.srvCampaign3.clientiDestinatiPromo.LOY) {

      if (this.tipoControllo) {
        this.tipoControllo.options = Object.assign([], this.comboTipoControllo);
        this.tipoControllo.fieldModel = this.messageInstanceObject.cardHolderType ? this.tipoControllo.options.find(x => x.value == this.messageInstanceObject.cardHolderType) : null;
        this.fieldModel.tipoControllo = this.messageInstanceObject.cardHolderType ? this.tipoControllo.options.find(x => x.value == this.messageInstanceObject.cardHolderType) : null;
      }

      /*da KS-5420, se il tipo azione è LOY allora la scelta di lista di distribuzione emissione è obbligatoria */
      this.listaDistribuzioneEmissione.required = true;

      //self.customerTargetComponent.listaDistribuzioneEmissione.disabled = false;
      this.listaDistribuzioneEmissione.disabled = this.readOnly;
      //self.customerTargetComponent.fieldModel.listaDistribuzioneEmissione = null;

      /*
      if(this.tipoControllo){
        this.tipoControllo.required = false;
        this.tipoControllo.disabled = this.readOnly;
      }
      */

      //this.switch.cartaNecessaria = false;
    }
  }
  resetSelectedClusterHeads() {
    for (let ce of this.clusterHeadNewList) {
      ce["rowSelected"] = false;
    }
  }
  onClickSearchListaDistribuzione(type: string) {
    this.currentSearchType = type;

    //E=emission, F=fruition
    if (type == "E") {
      if (!this.listaDistribuzioneEmissione.disabled) {
        this.distributionList = Object.assign([], this.distributionListEmission);
        this.show.modalDistributionList = true;
      }
    }
    /*  else if(type == "F"){
       if(!this.listaDistribuzioneFruizione.disabled){
         this.distributionList = Object.assign([],this.distributionListFruition);
         this.show.modalDistributionList = true;
       }
     } */

  }
  onClickAnnulla_ModalListDistribuzione() {
    this.show.modalDistributionList = false;
  }
  onClickAnnulla_ModalListDistribuzioneDetails() {
    this.show.modalDistributionListDetails = false;
  }
  onChangeListaDistribuzioneEmissione(event) {

  }
  /*  onChangeListaDistribuzioneFruizione(event){
     this.fieldModel.listaDistribuzioneFruizione = event;
     if(this.fieldModel.listaDistribuzioneFruizione && this.fieldModel.listaDistribuzioneFruizione.distributionListId>0){
       //-  Se imposto lista di fruizione non posso disabilitare carta loyalty.  (mail 05/06/2024)
       this.switch.cartaNecessaria = true;
       this.messageInstanceObject.flgCardHolder = "1";
       this.switchCartaNecessaria.disabled = true;
     
     }
     else{
       this.switch.cartaNecessaria = false;
       this.messageInstanceObject.flgCardHolder = "0";
       this.switchCartaNecessaria.disabled = this.formSchema.form[this.srvCampaign3.customerTargetFieldsName.switch_carta_necessaria].disabled == true ? true : this.readOnly;
     }
     this.messageInstanceObjectChange.emit(this.messageInstanceObject);
   } */
  onChangeTipoControllo(event) {

  }
  onClickVisualizzaContenutoListaEmissione() {

    if (this.fieldModel.listaDistribuzioneEmissione && this.fieldModel.listaDistribuzioneEmissione.distributionListId) {
      this.title.contenutoLista = "Contenuto Lista " + this.fieldModel.listaDistribuzioneEmissione.distributionListName;
      this.currentDistributionListId = this.fieldModel.listaDistribuzioneEmissione.distributionListId;
      this.show.modalDistributionListDetails = true;
      /*
      var self = this;
      this.srvCampaign3.getDistributionListDetails(this.fieldModel.listaDistribuzioneEmissione.distributionListId).subscribe(res=>{
        if(res && res.length>0){
          self.distributionListDetails = res;
          self.show.modalDistributionListDetails = true;
        }
        else{
          self.srvNotify.add({severity: 'error', summary: 'Attenzione', detail: "Nessun dettaglio da visualizzare" });
        }
      });
      */
    }
    else {
      this.title.contenutoLista = "Contenuto Lista";
    }
  }
  /*   onClickVisualizzaContenutoListaFruizione(){
      if(this.fieldModel.listaDistribuzioneFruizione && this.fieldModel.listaDistribuzioneFruizione.distributionListId){
  
        this.title.contenutoLista = "Contenuto Lista " + this.fieldModel.listaDistribuzioneFruizione.distributionListName;
        this.currentDistributionListId = this.fieldModel.listaDistribuzioneFruizione.distributionListId;
        this.show.modalDistributionListDetails = true;
  
      }
      else{
        this.title.contenutoLista = "Contenuto Lista";
      }
    } */
  onClickCreaNuovaLista(type) {
    this.currentNuovaListaEmissioneFruizione = type;
    // Il messaggio ha solo un periodo di emissione; per type 'F' non c'è un periodo da applicare.
    this.currentActionDateStart = type == "F" ? null : this.dataInizioEmissione;
    this.currentActionDateEnd = type == "F" ? null : this.dataFineEmissione;
    var self = this;
    this.resetSelectedClusterHeads();
    this.srvCampaign3.getClusterHeadNewList().subscribe(res => {
      if (res && res.length > 0) {
        self.clusterHeadNewList = res;
        self.show.modalClusterHeadNewList = true;
      }
      else {
        self.srvNotify.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translate.instant('campaign.no_cluster_to_visualize')
        });
      }
    })
  }
  onAnnullaClusterHead(toClose: boolean) {
    if (toClose)
      this.show.modalClusterHeadNewList = false;
  }
  reloadComboLists(idNewList: number) {
    var self = this;
    this.distributionList = null;
    this.srvCampaign3.getDistributionListCluster().subscribe(res => {
      if (res && res.length > 0) {

        let distrubutionListNull = new DistributionListCluster();
        distrubutionListNull.distributionListId = null;
        distrubutionListNull.distributionListName = "";

        self.distributionListEmission = Object.assign([], res);
        /*     self.distributionListFruition = Object.assign([],res); */
        self.distributionListEmission.unshift(distrubutionListNull);
        /*    self.distributionListFruition.unshift(distrubutionListNull); */

        self.listaDistribuzioneEmissione.options = Object.assign([], res);
        /*   self.listaDistribuzioneFruizione.options = Object.assign([],res); */
        self.listaDistribuzioneEmissione.options.unshift(distrubutionListNull);
        /*  self.listaDistribuzioneFruizione.options.unshift(distrubutionListNull); */

        self.comboListaDistribuzioneEmissione = Object.assign([], res);
        /*    self.comboListaDistribuzioneFruizione = Object.assign([],res); */
        self.comboListaDistribuzioneEmissione.unshift(distrubutionListNull);
        /*      self.comboListaDistribuzioneFruizione.unshift(distrubutionListNull); */

        if (self.listaDistribuzioneEmissione && !self.listaDistribuzioneEmissione.disabled && self.currentNuovaListaEmissioneFruizione == "E") {
          self.fieldModel.listaDistribuzioneEmissione = self.comboListaDistribuzioneEmissione.find(x => x.distributionListId == idNewList);
          self.listaDistribuzioneEmissione.fieldModel = self.comboListaDistribuzioneEmissione.find(x => x.distributionListId == idNewList);
        }
        /*  else if(self.listaDistribuzioneFruizione && !self.listaDistribuzioneFruizione.disabled && self.currentNuovaListaEmissioneFruizione == "F"){
           self.fieldModel.listaDistribuzioneFruizione = self.comboListaDistribuzioneFruizione.find(x=>x.distributionListId == idNewList);
           self.listaDistribuzioneFruizione.fieldModel = self.comboListaDistribuzioneFruizione.find(x=>x.distributionListId == idNewList);
         } */


      }
    });

  }
  onAggiungiClusterHead(modalData: { name: string, arrayClusterHeads: Array<ClusterHeadNewList> }) {
    var self = this;
    if (modalData.name && modalData.name.length > 0 && modalData.arrayClusterHeads && modalData.arrayClusterHeads.length > 0) {
      this.srvCampaign3.createDistributionList(modalData.name).subscribe(res => {
        if (res) {
          if (res && res.id) {
            let arrayId: Array<number> = [];
            for (let ch of modalData.arrayClusterHeads) {
              arrayId.push(ch.clusterHeadId);
            }
            var self2 = self;
            self.srvCampaign3.addClusterHeadList(res.id, arrayId).subscribe(res2 => {
              if (res2) {
                self2.reloadComboLists(res.id);
              }
              else {
                self2.srvNotify.add({
                  severity: 'error',
                  summary: 'Warning',
                  detail: this.translate.instant('campaign.unable_to_create_distribution_list')
                });
              }
              self2.show.modalClusterHeadNewList = false;
            })
          }
        }
        else {
          self.srvNotify.add({
            severity: 'error',
            summary: 'Warning', // Mantieni in inglese
            detail: this.translate.instant('campaign.unable_to_create_distribution_list')
          });
        }
      });
    }
    // this.show.modalClusterHeadNewList = false;
  }
  onClickCreaNuovaListaFruizione() {

  }
  /*   onChangeSwitchComeEmissione(value:boolean){
      this.switch.comeEmissione = value;
      if(value == true && this.fieldModel.listaDistribuzioneEmissione){
        if(!this.listaDistribuzioneFruizione.disabled){
          this.fieldModel.listaDistribuzioneFruizione = Object.assign({},this.fieldModel.listaDistribuzioneEmissione);
          this.onChangeListaDistribuzioneFruizione(Object.assign({},this.fieldModel.listaDistribuzioneEmissione));
        }
      }
    
    } */
  setSwitchCartaNecessaria(switchValue: boolean) {
    this.switch.cartaNecessaria = switchValue;
  }
  onChangeCartaNecessaria(switchValue: boolean) {
    this.switch.cartaNecessaria = switchValue;

    if (this.switch.cartaNecessaria == true) {

      /*    this.listaDistribuzioneFruizione.disabled = this.formSchema.form[this.srvCampaign3.customerTargetFieldsName.lista_distribuzione_fruizione].disabled == true ? true : this.readOnly;
         this.listaDistribuzioneFruizione.required = this.formSchema.form.lista_distribuzione_fruizione.required == true ? true : false; */
      this.messageInstanceObject.flgCardHolder = "1";

    }
    else {

      /**
       * - Se ho impostato i limti di fruizione nel tab condizioni di fruizione, non posso disabilitare carta loyalty. (mail 05/06/2024)
       * Flavio ha detto che basta uno solo dei limiti, perciò li metto in OR
       * */
      let rule_LM = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "LM").id);
      if (rule_LM) {
        let mir_PMNC = rule_LM.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PMNC").id);
        let mir_PMTC = rule_LM.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PMTC").id);
        let mir_PMCT = rule_LM.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PMCT").id);
        let mir_PTCM = rule_LM.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PTCM").id);

        if (mir_PMNC || mir_PMTC || mir_PMCT || mir_PTCM) {
          this.switchCartaNecessaria.disabled = true;
        }
        else {
          this.switchCartaNecessaria.disabled = this.formSchema.form[this.srvCampaign3.customerTargetFieldsName.switch_carta_necessaria].disabled == true ? true : this.readOnly;
        }
      }
      else {
        this.switchCartaNecessaria.disabled = this.formSchema.form[this.srvCampaign3.customerTargetFieldsName.switch_carta_necessaria].disabled == true ? true : this.readOnly;
      }


      //-  Se carta loyalty necessaria non è abilitato, non posso impostare lista di fruizione (mail 05/06/2024)
      /*  this.listaDistribuzioneFruizione.disabled = true;
       this.listaDistribuzioneFruizione.required = false; */
      this.fieldModel.tipoControllo = null;
      //this.fieldModel.listaDistribuzioneFruizione = null;
      //let indexToDelete = this.messageInstanceObject.messageInstanceRule.findIndex(x=>x.ruleTypeId == this.miRuleTypesList.find(x=>x.code == "CT").id);

      /*
      if(indexToDelete>-1){
        this.messageInstanceObject.messageInstanceRule.splice(indexToDelete,1);
      }
      */

      this.messageInstanceObject.flgCardHolder = "0";
    }


    /*da KS-5420, se cliccato carta loyalty necessaria, allora non bisogna indicare lista di fruizione, altrimenti è obbligatoria (implementato appena sopra) */
    /*
    if(this.switch.cartaNecessaria == false){
      this.fieldModel.listaDistribuzioneFruizione = null;
      this.listaDistribuzioneFruizione.required = true;
      this.listaDistribuzioneFruizione.disabled = this.readOnly;
      this.messageInstanceObject.flgCardHolder = "0";
    }
    else{
    
      this.listaDistribuzioneFruizione.required = false;
      this.listaDistribuzioneFruizione.disabled = true;
      this.messageInstanceObject.flgCardHolder = "1";
    }
    */

    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  onDistributionListSelected(event: DistributionListCluster) {
    if (this.currentSearchType == "E") {
      this.fieldModel.listaDistribuzioneEmissione = event;
    }

    this.show.modalDistributionList = false;

    this.checkVincoliCustomerTarget();
  }
  performValidationCustomerTarget(): boolean {

    this.listaDistribuzioneEmissione.performValidation();


    if (this.listaDistribuzioneEmissione.required && (!this.fieldModel.listaDistribuzioneEmissione || !this.fieldModel.listaDistribuzioneEmissione.distributionListId)) {
      this.listaDistribuzioneEmissione.valid = false;
    }


    if (this.switch.cartaNecessaria) {
      if (this.tipoControllo) this.tipoControllo.performValidation();
    }

    let error = false;

    if (!this.listaDistribuzioneEmissione.valid || (this.tipoControllo && !this.tipoControllo.valid)) {
      error = true;
    };

    this.valid = (error == false) ? true : false;

    return this.valid;
  }
  createRules() {

    this.CT_rules_emission = [];
    this.CT_rules_fruition = [];

    if (this.fieldModel.listaDistribuzioneEmissione && this.fieldModel.listaDistribuzioneEmissione.distributionListId) {
      let ruleCT = new MessageInstanceRule();
      ruleCT.messageInstanceId = this.messageInstanceObject.id;
      ruleCT.ruleTypeId = this.miRuleTypesList.find(x => x.code == "CT").id;
      ruleCT.ruleType = "CT";
      ruleCT.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
      ruleCT.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.EMISSION;

      let CT_mird = new MessageInstanceRuleDetail();
      CT_mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TDIS").id;
      CT_mird.objectTypeCode = "TDIS";
      CT_mird.objectId = this.fieldModel.listaDistribuzioneEmissione.distributionListId;
      ruleCT.messageInstanceRuleDetail.push(CT_mird);

      this.CT_rules_emission.push(ruleCT)
    }

    /*  if(this.fieldModel.listaDistribuzioneFruizione && this.fieldModel.listaDistribuzioneFruizione.distributionListId){
       let ruleCT = new MessageInstanceRule();
       ruleCT.messageInstanceId = this.messageInstanceObject.id;
       ruleCT.ruleTypeId = this.miRuleTypesList.find(x=>x.code == "CT").id;
       ruleCT.ruleType = "CT";
       ruleCT.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
       ruleCT.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.FRUITION;
 
       let CT_mird = new MessageInstanceRuleDetail();
       CT_mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TDIS").id;
       CT_mird.objectTypeCode = "TDIS";
       CT_mird.objectId = this.fieldModel.listaDistribuzioneFruizione.distributionListId;
       ruleCT.messageInstanceRuleDetail.push(CT_mird);
 
       this.CT_rules_fruition.push(ruleCT);
     } */
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-customer-target/message-3-customer-target.component.ts